import { createAsyncThunk } from '@reduxjs/toolkit';
import notify from '../../utils/notify';

//Include Both Helper File with needed methods
import {
  getContacts as getContactsApi,
  getCompanies as getCompaniesApi,
  getDeals as getDealsApi,
  getLeads as getLeadsApi,
  addNewCompanies as addNewCompaniesApi,
  updateCompanies as updateCompaniesApi,
  deleteCompanies as deleteCompaniesApi,
  addNewContact as addNewContactApi,
  updateContact as updateContactApi,
  deleteContact as deleteContactApi,
  addNewLead as addNewLeadApi,
  updateLead as updateLeadApi,
  deleteLead as deleteLeadApi,
} from '../../helpers/fakebackend_helper';

export const getContacts = createAsyncThunk('crm/getContacts', async () => {
  try {
    const response = getContactsApi();
    return response;
  } catch (error) {
    return error;
  }
});

export const getCompanies = createAsyncThunk('crm/getCompanies', async () => {
  try {
    const response = getCompaniesApi();
    return response;
  } catch (error) {
    return error;
  }
});

export const addNewCompanies = createAsyncThunk(
  'crm/addNewCompanies',
  async companies => {
    try {
      const response = addNewCompaniesApi(companies);
      notify.success('Company added successfully.');
      return response;
    } catch (error) {
      notify.apiError(error, 'add company');
      return error;
    }
  }
);

export const updateCompanies = createAsyncThunk(
  'crm/updateCompanies',
  async companies => {
    try {
      const response = updateCompaniesApi(companies);
      notify.success('Company updated successfully.');
      return response;
    } catch (error) {
      notify.apiError(error, 'update company');
      return error;
    }
  }
);

export const deleteCompanies = createAsyncThunk(
  'crm/deleteCompanies',
  async companies => {
    try {
      const response = deleteCompaniesApi(companies);
      notify.success('Company deleted successfully.');
      return { companies, ...response };
    } catch (error) {
      notify.apiError(error, 'delete company');
      return error;
    }
  }
);

export const addNewContact = createAsyncThunk(
  'crm/addNewContact',
  async contact => {
    try {
      const response = addNewContactApi(contact);
      notify.success('Contact added successfully.');
      return response;
    } catch (error) {
      notify.apiError(error, 'add contact');
      return error;
    }
  }
);

export const updateContact = createAsyncThunk(
  'crm/updateContact',
  async contact => {
    try {
      const response = updateContactApi(contact);
      notify.success('Contact updated successfully.');
      return response;
    } catch (error) {
      notify.apiError(error, 'update contact');
      return error;
    }
  }
);

export const deleteContact = createAsyncThunk(
  'crm/deleteContact',
  async contact => {
    try {
      const response = deleteContactApi(contact);
      notify.success('Contact deleted successfully.');
      return { contact, ...response };
    } catch (error) {
      notify.apiError(error, 'delete contact');
      return error;
    }
  }
);

export const getLeads = createAsyncThunk('crm/getLeads', async () => {
  try {
    const response = getLeadsApi();
    return response;
  } catch (error) {
    return error;
  }
});

export const addNewLead = createAsyncThunk('crm/addNewLead', async lead => {
  try {
    const response = addNewLeadApi(lead);
    notify.success('Lead added successfully.');
    return response;
  } catch (error) {
    notify.apiError(error, 'add lead');
    return error;
  }
});

export const updateLead = createAsyncThunk('crm/updateLead', async lead => {
  try {
    const response = updateLeadApi(lead);
    notify.success('Lead updated successfully.');
    return response;
  } catch (error) {
    notify.apiError(error, 'update lead');
    return error;
  }
});

export const deleteLead = createAsyncThunk('crm/deleteLead', async leads => {
  try {
    const response = deleteLeadApi(leads);
    notify.success('Lead deleted successfully.');
    return { leads, ...response };
  } catch (error) {
    notify.apiError(error, 'delete lead');
    return error;
  }
});

export const getDeals = createAsyncThunk('crm/getDeals', async () => {
  try {
    const response = getDealsApi();
    return response;
  } catch (error) {
    return error;
  }
});
